/**
 * ToolbarSpacer  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

export interface ToolbarSpacerProps {
	grow?: number | "inherit" | "initial" | "unset";
}

export const ToolbarSpacer: React.FC<ToolbarSpacerProps> = ({ grow }) => (
	<div className="edt-toolbar-spacer" style={{ flexGrow: grow }} />
);

ToolbarSpacer.defaultProps = {
	grow: 0
};
